import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.805 14.862l-3.979-3.979a6.68 6.68 0 0 0-.69-9.178C9.865.555 8.202-.062 6.489-.019S3.146.723 1.935 1.934.024 4.776-.019 6.489s.574 3.376 1.724 4.647 2.743 2.05 4.451 2.179 3.401-.405 4.727-1.489l3.979 3.979c.126.121.294.189.469.187s.342-.072.466-.195.194-.291.195-.466-.066-.343-.187-.469zM6.667 12c-1.055 0-2.086-.313-2.963-.899S2.143 9.682 1.739 8.708s-.509-2.047-.303-3.081.714-1.985 1.46-2.731 1.696-1.254 2.731-1.46 2.107-.1 3.081.303 1.807 1.087 2.394 1.964S12 5.612 12 6.667A5.34 5.34 0 0 1 6.667 12z" })
});
export default SvgSearch;
